import { groupBy } from 'lodash';
import { standardCollator as collator } from './string';

export function mapMembersToCohortList(members) {
  const cohortGroups = groupBy(
    members,
    (member) => member.cohort ?? 'Unassigned'
  );
  return Object.entries(cohortGroups)
    .sort(([, [a]], [, [b]]) => {
      if (a.cohort === b.cohort) {
        return 0;
      }
      if (a.cohort == null) {
        return 1;
      }
      if (b.cohort == null) {
        return -1;
      }

      return collator.compare(a.cohort, b.cohort);
    })
    .map(([cohort, members], i) => {
      const actualCohort = members[0].cohort;
      return {
        cohort: actualCohort,
        name: cohort,
        className:
          actualCohort == null
            ? 'unassigned-cohort'
            : `palette-cat-${(i % 21) + 1}`,
        members,
      };
    });
}
